import { DSButton, DSDialog, DSHeading, DSIcon, DSText } from '@stihl-design-system/components';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { useTranslation } from 'next-i18next';
import { defaultRenderOptions } from '@phoenix/core/frontend/shared/ui/contentful/renderer';

export const WarrantyExtensionConditionsDialog = ({
  preffix,
  additionalInformation,
  isOpen,
  onClose,
}: {
  preffix: string;
  additionalInformation: any;
  isOpen: boolean;
  onClose: () => void;
}) => {
  const { t } = useTranslation();

  return (
    <DSDialog
      id="warranty-extension-conditions-dialog"
      isOpen={isOpen}
      onClose={onClose}
      disableBackdropClose={true}
      header={
        <div className="flex gap-3">
          <div className="rounded-full bg-secondary-mid p-2 h-8">
            <DSIcon name="security" />
          </div>
          <DSHeading size="large">{t(`${preffix}_popup_warrantyExtensionConditions`)}</DSHeading>
        </div>
      }
      footer={
        <DSButton type="button" className="w-full tablet:w-fit" onClick={onClose}>
          {t('Close')}
        </DSButton>
      }
    >
      {additionalInformation && <DSText>{documentToReactComponents(additionalInformation?.json, defaultRenderOptions)}</DSText>}
    </DSDialog>
  );
};
